import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trovacantieri/trovacantieri-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// User Model
import Vue from 'vue';
import VuexORM from '@vuex-orm/core';
import Company from "./Company";
import Price from "./Price";
import moment from 'moment';
var Subscription = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Subscription, _VuexORM$Model);
  var _super = _createSuper(Subscription);
  function Subscription() {
    _classCallCheck(this, Subscription);
    return _super.apply(this, arguments);
  }
  _createClass(Subscription, [{
    key: "statusName",
    get: function get() {
      switch (this.stripe_status) {
        case 'trialing':
          return 'In prova';
        case 'active':
          return 'Attivo';
        case 'incomplete':
          return 'Pagamento incompleto';
        case 'incomplete_expired':
          return 'Pagamento incompleto scaduto';
        case 'past_due':
          return 'Scaduto';
        case 'canceled':
          return 'Annullato';
        case 'unpaid':
          return 'Non pagato';
      }
      return '';
    }
  }, {
    key: "formattedCreation",
    get: function get() {
      return moment(this.created_at).format('DD/MM/YYYY HH:mm');
    }
  }, {
    key: "formattedPeriodEnd",
    get: function get() {
      return moment(this.current_period_end).format('DD/MM/YYYY HH:mm');
    }
  }], [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'subscriptions';
    }

    // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
  }, {
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        company_id: this.attr(null),
        company: this.belongsTo(Company, 'company_id'),
        name: this.attr(''),
        stripe_id: this.attr(''),
        stripe_status: this.attr(''),
        stripe_plan: this.attr(''),
        plan: this.belongsTo(Price, 'stripe_plan'),
        ends_at: this.attr(''),
        trial_ends_at: this.attr(''),
        created_at: this.attr(''),
        current_period_end: this.attr('')
      };
    }
  }, {
    key: "$cancelSubscription",
    value: function $cancelSubscription(subscription) {
      return Vue.prototype.$axios.put('/api/subscriptions/' + subscription.id + '/cancel').then(function (response) {
        Subscription.insert({
          data: response.data
        });
      });
    }
  }]);
  return Subscription;
}(VuexORM.Model);
export { Subscription as default };